export default "__VITE_ASSET__BElgd65v__"